<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/97Fzvv/tc-custom/cover.jpg?1688985319157?1699705885402" alt="This image is the cover for the book Business and Marketing, New York State Teacher Certification Examination Series (NYSTCE)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Business and Marketing, New York State Teacher Certification Examination Series (NYSTCE)
      </h1>
      <p class="bookDescription body article font2">
        <p>The New York State Teacher Certification Exams (NYSTCE) are required for all candidates seeking licensure in the State.  The NYSTCE series consists of many different tests assessing skills and abilities necessary for teachers.  The Passbook® for the Content Specialty Test in Business and Marketing provides hundreds of multiple-choice questions in the areas that will likely be covered on your upcoming certification exam, including but not limited to: business management; marketing principles; accounting; consumer economics; entrepreneurship; and other related areas.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        National Learning Corporation
      </h2>
      
      <p class="authorDescription body article">National Learning Corporation has been a leading publisher of test-preparation Passbooks® for more than 50 years, with 6,000 titles available across 22 series.  The Career Examination Series features thousands of titles designed to prepare test candidates for their upcoming civil-service job exam.  Each book in the Career Series offers practice through multiple-choice questions and answers in relevant subject areas, as well as informative texts to aid in understanding the study material.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      National Learning Corporation
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a0e1e60c